import React from 'react'
import PropTypes from "prop-types";
import './youtube-embed.css'

const Youtube = (props) => {
  return (
    <div className="iframe__wrapper">
      <div className="iframe__block">
        <iframe title={"iframe_1"} width="100%" height="100%" src={props.link} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen />
      </div>
    </div>
  )
}

Youtube.propTypes = {
  link: PropTypes.string
}

export default Youtube


// WEBPACK FOOTER //
// ./src/components/youtube-embed/youtube-embed.js